// Navegación del menú principal
export const MENU_ITEMS = [
  { id: 'inicio', label: 'INICIO', href: '/' },
  {
    id: 'invitaciones',
    label: 'INVITACIONES',
    isDropdown: true,
    items: [
      { label: 'Clásica', href: '/' },
      { label: 'Premium', href: '/' },
      { label: 'Black', href: '/' },
      { label: 'Romántica', href: '/' },
      { label: 'Vintage', href: '/' },
      { label: '15 años', href: '/' }
    ]
  },
  { id: 'blog', label: 'OPCIONES', href: '#contacto' },
  { id: 'contacto', label: 'CONTACTO', href: '#contacto', smooth: true }
];
